import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import LockIcon from "@mui/icons-material/Lock";
import LoginLogoutButton from "../components/auth/login-logout-button";

const NoAccessPage: React.FC = () => {

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "#000",
      }}
    >
      <Box
        sx={{
           alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          bgcolor: "#1e1e1e",
          padding: 4,
          borderRadius: 2,
          boxShadow: 3,
          border: "1px solid #333",
        }}
      >
        <LockIcon
          sx={{
            fontSize: 80,
            color: "hsl(19 101% 51% / 1)",
            mb: 2,
          }}
        />

        <Typography
          variant="h4"
          component="h1"
          gutterBottom
          fontWeight="bold"
          color="hsl(19 101% 51% / 1)"
        >
          Access Pending
        </Typography>

        <Typography variant="h6" component="h2" gutterBottom color="#fff">
          Your account is authenticated but not authorized
        </Typography>

        <Typography variant="body1" sx={{ mb: 4, color: "#aaa" }}>
          We could not find any roles or permissions assigned to your account.
          Please contact your administrator to request access.
        </Typography>

        <Box sx={{ display: "flex", gap: 2, justifyContent: "center" }}>
           <LoginLogoutButton showBugReport={false} />
        </Box>
      </Box>
    </Box>
  );
};

export default NoAccessPage;
